import React from 'react';
import { WEEKDAY_INITIALS, buildMonthGrid, formatMonthLabel, isWeekend, parseIso } from '../../utils/ipoCalendar';
import { TYPE_STYLES, dominantType } from './calendarStyles';

const LEGEND = [
  { type: 'open', label: 'Bidding Opens' },
  { type: 'close', label: 'Bidding Closes' },
  { type: 'allotment', label: 'Allotment' },
  { type: 'holiday', label: 'Holiday' },
];

// Compact month heatmap for the sidebar; days with events jump to the timeline
export const MonthMatrixCard = ({ monthKey, eventsByDate, today, onSelectDay }) => (
  <section className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5" aria-labelledby="calendar-matrix-heading">
    <div className="flex items-center justify-between gap-2">
      <h2 id="calendar-matrix-heading" className="text-sm font-extrabold text-slate-900">
        {formatMonthLabel(monthKey)} Matrix
      </h2>
      <span className="px-2 py-0.5 rounded-md border border-teal-200 bg-teal-50 text-[10px] font-bold text-[#006666]">
        Interactive Heatmap
      </span>
    </div>

    <div className="grid grid-cols-7 gap-1 mt-4 text-center">
      {WEEKDAY_INITIALS.map((initial, index) => (
        <span key={`${initial}-${index}`} className="text-[10px] font-bold text-slate-400 pb-1">
          {initial}
        </span>
      ))}
      {buildMonthGrid(monthKey).map((iso, index) => {
        if (!iso) return <span key={`pad-${index}`} />;
        const events = eventsByDate.get(iso) || [];
        const type = dominantType(events);
        const isToday = iso === today;
        const tone = type
          ? TYPE_STYLES[type].cell
          : isWeekend(iso)
            ? 'text-slate-300'
            : 'text-slate-600';
        return (
          <button
            key={iso}
            type="button"
            disabled={!events.length}
            onClick={() => onSelectDay(iso)}
            title={events.length ? `${events.length} event${events.length === 1 ? '' : 's'}` : undefined}
            className={`aspect-square rounded-md text-[11px] font-bold flex items-center justify-center transition-colors disabled:cursor-default ${tone} ${
              isToday ? 'ring-2 ring-[#008080] ring-offset-1' : ''
            }`}
          >
            {parseIso(iso).getDate()}
          </button>
        );
      })}
    </div>

    <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-1.5">
      {LEGEND.map(({ type, label }) => (
        <li key={type} className="flex items-center gap-1.5 text-[11px] text-slate-500">
          <span className={`w-2.5 h-2.5 rounded-sm ${TYPE_STYLES[type].dot}`} />
          {label}
        </li>
      ))}
    </ul>
  </section>
);

export default MonthMatrixCard;
